export interface UserState {
    name?: string
    nickName?: string;
    password?: string;
    changePassword?: number;
    idPerson?: number;
    disabled?: number;
    administrator?: number;
    attendant?: number;
    approver?: number;
    urgency?: number;
    urgencyPermission?: number;
    hourValue?: number;
    functionPoint?: number;
    idSla?: any;
    idCalendar?: any;
    allowNormalSolicitation?: number;
    idProfile?: number;
    allowForwardWork?: number;
    passwordSha256?: any;
    allowSchedule?: number;
    allowFutureTime?: number;
    allowExpenseCompleted?: number;
    allowFinancialCompleted?: number;
    productivity?: number;
    productivityTime?: number;
    allowChangeTime?: number;
    projectManager?: number;
    allowViewContract?: number;
    blockConsiderAttendant?: number;
    adjustedWorkingTime?: number;
    codeIntegration?: any;
    allowFastSolicitation?: number;
    allowAttachmentComment?: number;
    obeyOrderService?: number;
    attendantReopenSolicitation?: number;
    loadNormalSolicitation?: number;
    quantityLines?: number;
    dashboard?: number;
    viewRequestCustomer?: number;
    blockConsiderTeam?: number;
    allowNewUserNormalSolicitation?: number;
    allowOperationalMenuManagementInSight?: number;
    id?: number;
    Photo?: string;
    defaultCustomer?: any,
    businessAreas?: any[],
    selectedDefaultView?: string,
    requiredSolicitationGroup?: number;
}

export interface WebPresence {
    costCenterId?: number, 
}

export const webPresenceReducer = (state: WebPresence = {}, action: Action) => {      
    switch (action.type) {
        case 'COSTCENTERUPDATE': return state = action.payload;                   
        default: return state;
    }
}

type Action = { type: string, payload: any }

export const userReducer = (state: UserState = {}, action: Action) => {
    switch (action.type) {
        case 'USER_UPDATE': return state = action.payload;
        case 'USER_UPDATE_REFRESH': return { ...state, refreshFlag: action.payload };
        case 'USER_UPDATE_ATTENDANTSELECTEDVIEW': return { ...state, selectedDefaultView: action.payload };
        default: return state;
    }
}